
const API_KEY = 'ea9272ba0be86f8024c97d566497f993';

export default API_KEY;